<div class="modal modal_size_744 modal__opened">
  <div class="modal__close icon icon-close" (click)="close()"></div>
  <div class="modal__container">
    <div class="modal__img">
      <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
    </div>
    <div class="modal__title modal__title-mb12 h2">{{ 'subscriber-ugc-page.checking-track' | translate }}</div>
    <div class="modal__text">{{ 'subscriber-ugc-page.checking-track-full' | translate }}</div>
  </div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button" (click)="close()">{{ 'subscriber-ugc-page.clear' | translate }}</div>
  </div>
</div>
